module.exports = __webpack_public_path__ + "static/media/replacement1x.9b493aee.jpg";